import React from "react";

const CircleArrowIcon = ({
	size,
	direction = "right",
	circleColor = "#ffffff",
	arrowColor = "#0066a0",
	variant = "default"
}) => {
	const isLegacyLeft = variant === "legacy" && direction === "left";

	const iconSize = size || (isLegacyLeft ? 25 : 21);
	const viewBox = isLegacyLeft ? "0 0 25 25" : "0 0 21 21";
	const circleRadius = isLegacyLeft ? 12.5 : 10.5;
	const circleCenter = isLegacyLeft ? 12.5 : 10.5;

	const rotationByDirection = {
		right: -90,
		left: 90,
		down: 0,
		up: 180
	};

	const arrowTransform = isLegacyLeft
		? `translate(8.091 16.179) rotate(-90)`
		: `translate(6.95 7.3) rotate(${rotationByDirection[direction] || 0} 3.55 3.55)`;

	const arrowPath = isLegacyLeft
		? "M4.831.346l3.6,7.033a.653.653,0,0,1-.983.81l-2.794-2.2a.613.613,0,0,0-.79,0l-2.813,2.2a.654.654,0,0,1-.983-.81L3.675.346a.656.656,0,0,1,1.156,0Z"
		: "M4.026,6.652l3-5.861A.544.544,0,0,0,6.209.117L3.882,1.947a.511.511,0,0,1-.658,0L.879.117A.545.545,0,0,0,.06.791l3,5.861a.546.546,0,0,0,.964,0Z";

	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={iconSize}
			height={iconSize}
			viewBox={viewBox}
			aria-hidden="true"
			focusable="false"
		>
			<circle
				cx={circleCenter}
				cy={circleCenter}
				r={circleRadius}
				fill={circleColor}
			/>

			<path
				d={arrowPath}
				transform={arrowTransform}
				fill={arrowColor}
			/>
		</svg>
	);
};

export default CircleArrowIcon;